export function smoothScrollOnPageLoad() {
    
    let win = window, doc = document;

    // Smooth scroll on page load if the URL has a fragment identifier 
    if ( win.location.hash ) {
        
        // Hash
        let _hash = win.location.hash;
        
        // Wlement with the id corresponding to the hash fragment exists
        if ( doc.getElementById( _hash.replace( '#','' ) ) ) {

            let $siteheader = $('.site-header').height();

            doc.addEventListener( "DOMContentLoaded", function() {
                
                if ( Foundation.SmoothScroll ) {

                    let smoothScrollOptions = {
                      animationDuration: 500,
                      animationEasing: 'linear',
                      threshold: 50,
                      offset: $('.site-header').height()
                    }

                    Foundation.SmoothScroll.scrollToLoc(_hash, smoothScrollOptions, function() {

                        console.log('Scroll Complete');

                    } );
                    
                }

            } );

        }

    }

}
